import './SkillItem.css';

const SkillItem = (props) => {
  return (
    <div className="skill__slider__slide" key={props.key}>
      <div>
        {props.icon ? <i className={props.icon}></i> : <h3>{props.name}</h3>}
        <div className="skill__slider__popup">{props.name}</div>
      </div>
    </div>
  );
};

export default SkillItem;
